// Simple profanity filter for content moderation
const profaneWords = [
  'damn', 'hell', 'shit', 'fuck', 'bitch', 'bastard', 'ass', 'crap',
  // Add more as needed - this is a basic list
];

export const containsProfanity = (text: string): boolean => {
  const lowerText = text.toLowerCase();
  return profaneWords.some(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'i');
    return regex.test(lowerText);
  });
};

export const filterProfanity = (text: string): string => {
  let filtered = text;
  profaneWords.forEach(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    filtered = filtered.replace(regex, '*'.repeat(word.length));
  });
  return filtered;
};

export const validateContent = (text: string): { isValid: boolean; message?: string } => {
  if (!text.trim()) {
    return { isValid: false, message: 'Content cannot be empty' };
  }

  if (containsProfanity(text)) {
    return { isValid: false, message: 'Content contains inappropriate language' };
  }

  if (text.length > 5000) {
    return { isValid: false, message: 'Content is too long (max 5000 characters)' };
  }

  return { isValid: true };
};
